{
  "add_additional_information": "Add additional information",
  "conditions": "Conditions",
  "count_pending": "{count} pending",
  "create_another_job": "Create another job and link",
  "create_job": "Create job and link",
  "creation_request_hiring_plan": "Creation position request",
  "editing_request_hiring_plan": "Editing position request",
  "enter_conditions": "Enter your conditions",
  "enter_requirements": "Enter your requirements",
  "enter_responsibilities": "Enter your responsibilities",
  "hiring_plan": "Hiring plan",
  "hiring_plan_description": "Manage position requests and hiring plan",
  "link_another_exist_job": "Link to another existing job",
  "link_exist_job": "Link to existing job",
  "link_job": "Link to a job",
  "linked_job": "Linked job",
  "manage_title": "Manage hiring plan",
  "new_employee_required": "When new employee required",
  "notification_settings_hiring_plan_caption": "When your approval is required or response to your request",
  "plan_date": "Plan date",
  "position": "Position",
  "position_request": "Position request",
  "position_requests": "Position requests",
  "request_new_position": "Request new position",
  "request_status_hired": "Hired",
  "request_status_hiring": "Hiring",
  "requirements": "Requirements",
  "responsibilities": "Responsibilities",
  "select_job": "Select a job vacancy",
  "unlink": "Unlink",
  "view_job": "View job",
  "view_request": "View request",
  "~": "~"
}
